/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit HandPointEasy/view.blocks to change it.
import React from 'react'
import sourcePng from "./source.png"
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function HandPointEasy({
  children,
  viewPath = "/DesignSystem/Images/HandPointEasy",
  alignSelf = "auto",
  backgroundColor = "transparent",
  borderBottomLeftRadius = 0,
  borderBottomRightRadius = 0,
  borderTopLeftRadius = 0,
  borderTopRightRadius = 0,
  height = 206,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  source = sourcePng,
  width = 600
  
}) {
  return (<React.Fragment
>
<img
  data-testid="HandPointEasy.Image"
  data-view-path={viewPath}
 alt={""}
 src={source}
 style={{'--as-1-1aevAX': alignSelf,'--bc-2-1aevAX': backgroundColor,'--bblr-3-1aevAX': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-4-1aevAX': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-1aevAX': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-1aevAX': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--h-7-1aevAX': typeof height === 'number' ? `${height}px` : height,'--mb-8-1aevAX': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-9-1aevAX': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-10-1aevAX': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-11-1aevAX': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--w-12-1aevAX': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}